<template>

  <!-- TABLE -->
  <tr
  :class="[{'selected': selected[item.id]}, {'disabled': disabled}, {'active': active}]">
    <td class="sticky">

      <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="grey"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
              <json-viewer :item="item"></json-viewer>
            </span>
          </div>
        </v-card>
      </v-menu>

      <v-layout align-center>

        <!--
        <v-btn
        icon
        @click.stop="$emit('checkRow', item)">
          <v-icon> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        -->

        <c-peek-definition :definition="item.definition" :searchString="searchFilters.name" style="white-space: normal;" :class="[{'green--text': item.marking1}, {'red--text': item.marking2}]">
        </c-peek-definition>
       
      </v-layout>
    </td>
    <td>

      <span
      class="underline-link"
      @click.stop="$root.$timelineNav.open(item.archive_id)">
        RID:
        {{ item.archive_id }}
      </span>

    </td>
    <td>
      {{ item.batch_number }}
    </td>
    <td>
      <v-chip v-if="hasExpired"
      color="pink"
      x-small
      text-color="white">
        EXPIRED
      </v-chip>
      <div v-if="item.expiry_date" class="caption">
        {{ hasExpired? 'expired' : 'expires' }} {{ expiryDateHuman }} <br /> ({{ expiryDate }})
      </div>
      <div v-else class="caption textSecondary--text">
        (not set)
      </div>
    </td>
    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue="item.quantity"
      :key="item.id"
      alwaysScale
      labelMode
      ></c-ms-ii>
    </td>
  </tr>
</template>

<script>
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: {
    item: null,
    searchFilters: null,
    selected: null,
    disabled: null,
    active: null
  },
  components: {
    JsonViewer
  },
  data () {
    return {
      hover: false
    }
  },
  computed: {
    expiryDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('DD MMM YYYY')
      }
      return ''
    },
    expiryDateHuman () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment.utc(this.item.expiry_date).fromNow()
      }
      return ''
    },
    hasExpired () {
      return this.$moment.utc(this.item.expiry_date).isBefore()
    }
  }
}
</script>

<style scoped lang="scss">

</style>